import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	buttonLabel: {
		id: 'software-releases-launch-card.version-status.button-label',
		defaultMessage: 'Version release state dropdown',
		description: 'Label for select trigger button icon',
	},
	archiveOptionLabel: {
		id: 'software-releases-launch-card.version-status.archive-option-label',
		defaultMessage: 'Archive',
		description: 'Label for the "archive" option',
	},
	archivedLabel: {
		id: 'software-releases-launch-card.version-status.archived-label',
		defaultMessage: 'Archived',
		description: 'Label value of version status button when version is archived',
	},
	releasedLabel: {
		id: 'software-releases-launch-card.version-status.released-label',
		defaultMessage: 'Released',
		description: 'Label value of version status button when version is released',
	},
	releaseOptionLabel: {
		id: 'software-releases-launch-card.version-status.release-option-label',
		defaultMessage: 'Release',
		description: 'Label for the "release" option',
	},
	unarchiveOptionLabel: {
		id: 'software-releases-launch-card.version-status.unarchive-option-label',
		defaultMessage: 'Unarchive',
		description: 'Label for the "unarchive" option',
	},
	unreleaseOptionLabel: {
		id: 'software-releases-launch-card.version-status.unrelease-option-label',
		defaultMessage: 'Unrelease',
		description: 'Label for the "unrelease" option',
	},
	unreleasedLabel: {
		id: 'software-releases-launch-card.version-status.unreleased-label',
		defaultMessage: 'Unreleased',
		description: 'Label value of version status button when version is unreleased',
	},
	archiveFailedFlagDescription: {
		id: 'software-releases-launch-card.version-status.archive-failed-flag-description',
		defaultMessage:
			'We were not able to update the version archived status. Please refresh the page and try again.',
		description: 'The description of the error flag when relase fails',
	},
	genericUpdateFailedFlagTitle: {
		id: 'software-releases-launch-card.version-status.generic-update-failed-flag-title',
		defaultMessage: 'Something went wrong',
		description:
			'The title of the error flag when updating the version released or archived status fails',
	},
	releaseFailedFlagDescription: {
		id: 'software-releases-launch-card.version-status.release-failed-flag-description',
		defaultMessage:
			'We were not able to update the version released status. Please refresh the page and try again.',
		description: 'The description of the error flag when relase fails',
	},
});
